import React from "react";
import MarketTableLeaderboard from "./MarketTableLeaderboard";
import MarketTableMasterTraders from "./MarketTableMasterTraders";
import MarketTableTopGainer from "./MarketTableTopGainer";
import { MarketTraderListSection } from "./styles";

const MarketTraderList = () => {
  return (
    <MarketTraderListSection>
      <MarketTableTopGainer />
      <MarketTableLeaderboard />
      <MarketTableMasterTraders />
    </MarketTraderListSection>
  );
};

export default React.memo(MarketTraderList)
